import React from "react";
import { useSelector } from "react-redux";
import GlobalDeleteDialog from "../../../../components/mui/Dialogue/GlobalDeleteDialog";
import {
  deleteLeaveGrantApplication,
  getLeaveGrantRequests,
} from "../../../../redux/features/leaveSlice";

const DeleteLeaveGrantRequest = ({ leaveID, dispatchdata, disabled }) => {
  const { loading } = useSelector((state) => state.leave);
  const { paginationData, openAnchor } = useSelector(
    (state) => state.globalDataGrid
  );

  return (
    <GlobalDeleteDialog
      title={"Delete Leave Grant Request"}
      disabled={disabled}
      deleteNote={"Are you sure? you want to delete this request..?"}
      api={deleteLeaveGrantApplication(leaveID)}
      upDateCall={getLeaveGrantRequests(dispatchdata)}
      loading={loading}
    />
  );
};

export default DeleteLeaveGrantRequest;
